import React, {FC, useEffect} from "react";
import {useLocation} from "react-router";
import Header from "./Header";
import FullLayoutSidebar from "./Sidebar";
import {usePersistedToggle, useToggle} from "../../hooks";
import './style.css';

// Remembered across reloads so a collapsed rail stays collapsed (SD-4167).
const NAV_COLLAPSED_KEY = "sudonum.nav-collapsed";

const FullLayout: FC = ({ children }) => {
  const location = useLocation();
  // `sidebarCollapsed` is the MOBILE drawer, and reads inverted to its name:
  // it starts true meaning "drawer closed", and the scrim below shows when it
  // is false. `navCollapsed` is the separate desktop icon-rail state added by
  // SD-4167 -- the two are independent, so collapsing the rail on desktop must
  // not open the drawer on mobile.
  const [sidebarCollapsed, toggleSidebar] = useToggle(true);
  const [navCollapsed, toggleNav] = usePersistedToggle(NAV_COLLAPSED_KEY, false);

  useEffect(() => {
    const element = document.querySelector('.full-layout');
    element.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location]);

  return (
    <div className="full-layout w-full h-screen flex flex-col">
      <Header
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebar={toggleSidebar}
      />
      <div className="h-0 flex-grow flex relative">
        <FullLayoutSidebar
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={toggleSidebar}
          navCollapsed={navCollapsed}
          onToggleNav={toggleNav}
        />
        <div className="page-content w-0 h-full flex-grow bg-gray-f8 md:ml-14 lg:m-0 overflow-auto">
          {children}

          {!sidebarCollapsed && (
            <div
              className="lg:hidden fixed top-0 left-0 !z-[999] w-screen h-screen bg-black opacity-40"
              onClick={toggleSidebar}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FullLayout;
